import NextLink from "next/link";
import { ChakraListItem as ListItem, ChakraLink as Link } from "@airhelp/react-ui-components";
import type { SideMenuItemProps } from "./SideMenuItem.d";

const SideMenuItem = ({ heading, isActive }: SideMenuItemProps) => {
  const { current: { id, textContent } = {} } = heading;

  return (
    <ListItem>
      <Link
        as={NextLink}
        href={`#${id}`}
        position="relative"
        color={isActive ? "primary.700" : "primary.900"}
        fontWeight={isActive ? "medium" : "regular"}
        _hover={{ textDecoration: "none" }}
        _before={
          isActive
            ? {
                content: `""`,
                position: "absolute",
                width: "7px",
                height: "7px",
                background: "primary.500",
                borderRadius: "full",
                left: "-16px",
                top: "6px",
              }
            : null
        }
        _focus={{
          outline: "none",
        }}
        _visited={{}}
      >
        {textContent}
      </Link>
    </ListItem>
  );
};

export default SideMenuItem;
